import { AfterViewInit, Component, OnInit, inject, input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { loadStripe } from '@stripe/stripe-js/pure';
import { Stripe, StripeCardElement } from '@stripe/stripe-js';

import { environment } from './../../environments/environment';
import { PlanComponent } from '../pricing/plan/plan.component';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { AccountService, Subscription, UpgradeAccount } from '../shared/services/account.service';

@Component({
  selector: 'app-upgrade',
  standalone: true,
  imports: [ReactiveFormsModule, PlanComponent],
  templateUrl: './upgrade.component.html',
  styleUrl: './upgrade.component.scss'
})
export class UpgradeComponent implements OnInit, AfterViewInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private accountService = inject(AccountService);
  private userService = inject(UserService);
  public upgradeToAnual = '';

  private formBuilder = inject(FormBuilder);
  form = this.formBuilder.group({
    subscription: ['', Validators.required]
  },
    { updateOn: 'blur' }
  );

  public planType = '';
  public clientClaim = '';
  public subscriptions: Subscription[] = [];
  public cardError?: string;
  public submitDisabled = false;
  public state = this.userService.state()
  private user? = this.userService.state();
  private stripe: Stripe | null = null;
  private card?: StripeCardElement;

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.planType = params['plan'];
        this.clientClaim = this.planType.replace('Standard', '');
        this.upgradeToAnual = params['upgradeToAnual']
        if (this.planType == undefined) this.planType = 'PeerComparisonStandard'
      });

    this.accountService.getSubscriptions(this.planType)
      .subscribe(subscriptions => {

        if (this.upgradeToAnual == 'true') {
          this.subscriptions = subscriptions.filter(items => items.name !== 'Monthly Standard');
        }
        else {
          this.subscriptions = subscriptions;

        }
      });
  }
  ngAfterViewInit(): void {
    this.initStripe();
  }

  async initStripe() {
    const style = {
      base: {
        iconColor: '#FFFFFF',
        color: '#FFFFFF',
        fontWeight: '400',
        fontFamily: 'Open Sans, sans-serif',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        ':-webkit-autofill': {
          color: '#111111',
        },
        '::placeholder': {
          color: '#FFFFFF',
        },
      },
      invalid: {
        iconColor: '#FF99AA',
        color: '#FF99AA',
      },
    }

    this.stripe = await loadStripe(environment.stripePublicKey);
    const elements = this.stripe?.elements();
    this.card = elements?.create('card', { style: style });
    this.card?.mount('#card-element');
    this.card?.on('change', (event: any) => {
      this.cardError = event.error?.message;
    });
  }

  async onSubmit() {
    this.submitDisabled = true;

    const email = this.user?.userName;
    const name = `${this.user?.firstName} ${this.user?.lastName}`;
    const institutionId = this.user?.organizationId;
    const subscription = this.form.value.subscription;
    const stripePriceId = this.subscriptions.find(s => s.id == subscription)?.stripeId;
    const planType = this.planType;

    const { error: paymentMethodError, paymentMethod } = await this.stripe!.createPaymentMethod({
      type: 'card',
      card: this.card!,
      billing_details: {
        name: name,
        email: email
      }
    });

    if (paymentMethodError) {
      this.cardError = paymentMethodError.message;
      this.submitDisabled = false;
      return;
    }


    this.accountService.upgradeBillingAccount(email!, name!, institutionId!, stripePriceId!, paymentMethod.id, this.clientClaim)
      .subscribe(billingAccount => {

        if (billingAccount.clientSecret) {
          this.stripe?.confirmCardPayment(billingAccount.clientSecret, {
            payment_method: paymentMethod.id
          }).then((result) => {
            if (result.error) {
              this.cardError = result.error.message;
              this.submitDisabled = false;
            }
            else {
              this.completeUpgrade(institutionId!, subscription!, billingAccount.subscriptionId, planType, email!, name);
            }
          });

        }
        else {
          // No payment required (upgrade was processed successfully without additional payment)
          // This happens when:
          // - Proration results in a credit
          // - Upgrade amount is covered by existing credits
          // - Very small amounts that don't require payment
          this.completeUpgrade(institutionId!, subscription!, billingAccount.subscriptionId, planType, email!, name);
        }
      });
  }

  private completeUpgrade(organizationId: string, subscriptionId: string, billingSubscriptionId: string, planType: string, email: string, name: string) {
    const model: UpgradeAccount = {
      organizationId: organizationId,
      subscriptionId: subscriptionId,
      billingSubscriptionId: billingSubscriptionId,
      planType: planType,
      email: email,
      name: name
    };

    this.userService.refreshUserState().subscribe();
    this.accountService.upgradeAccount(model)
      .subscribe(() => {
        this.router.navigate(['/upgrade/thankyou']);
      });
  }
}


